export default __webpack_public_path__ + "contentmodules/UCS_Sign_In_Audience-color.fb3c2b29.png";